  (function () {
    function ensureRecentlyViewedInit() {
      document.querySelectorAll('recently-viewed').forEach(function (el) {
        if (el.children.length > 0) return;       // already populated
        if (typeof el.init !== 'function') return; // class not loaded yet
        try { el.init(); } catch (e) { /* ignore */ }
      });
    }

    if (document.readyState === 'complete') {
      ensureRecentlyViewedInit();
    } else {
      window.addEventListener('load', ensureRecentlyViewedInit);
    }

    // Safety nets in case the custom element upgrades late
    setTimeout(ensureRecentlyViewedInit, 1500);
    setTimeout(ensureRecentlyViewedInit, 4000);

    // Handle bfcache (browser back/forward)
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) ensureRecentlyViewedInit();
    });
  })();
